import React, { useRef, useCallback } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
  TextField,
  SelectField,
  useListContext,
  ReferenceField,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import moment from 'moment';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
//import ActionsField from './ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_FERIADOS_LISTAR } from '../../utils/dadosTelas';
import {
  choicesTipo,
  choicesUniverso,
  choicesStatusLoja,
  choicesTipoHorario,
} from './choices';
import DataField from './DataField';
import DataFolgaField from './DataFolgaField';
import DateInputMobills from './DateInputMobills';
import Dialogo from './DialogoCreateEdit';
import DialogoDeleteResource from './DialogoDeletar';
import Filter from './Filter';
import StatusLojaField from './StatusLojaField';
import TipoHorarioField from './TipoHorarioField';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);
  const listContext = useListContext();
  const { filterValues, setFilters, displayedFilters } = listContext;
  const refresh = useRefresh();
  const classes = useStyles();

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }
  function deleteHundle({ id }) {
    if (refDialogoDeleteResource.current)
      refDialogoDeleteResource.current.handleOpen(id);
  }

  const handleClose = () => {
    refresh();
  };

  const handleChangeAno = useCallback(
    (ano) => {
      if (setFilters) {
        setFilters({ ...filterValues, ano }, displayedFilters);
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  return (
    <>
      <Title title="Feriados" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <div
          style={{
            margin: '10px 0px',
          }}
        >
          <DateInputMobills handleAno={(value) => handleChangeAno(value)} />
        </div>
        <Datagrid {...props}>
          <TextField source="id" label="ID" />
          <TextField source="nome" label="Descrição" />
          <DataField source="data" label="Data" />
          <SelectField
            sortable={false}
            source="tipo"
            label="Tipo"
            choices={choicesTipo}
          />
          <SelectField
            sortable={false}
            source="universo"
            label="Universo"
            choices={choicesUniverso}
          />
          <StatusLojaField
            sortable={false}
            source="status_loja"
            label="Status da Loja"
            choices={choicesStatusLoja}
          />
          <TipoHorarioField
            sortable={false}
            source="tipo_horario"
            label="Tipo de Horário"
            choices={choicesTipoHorario}
          />
          <ReferenceField
            label="Equipe"
            source="equipe_colaborador_id"
            reference="equipes_colaborador"
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <DataFolgaField source="data_folga" label="Data da Folga" />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            /* handleDelete={deleteHundle}
            handleEdit={handleEdit}
            ativo */
            actions={[
              {
                key: 'recorrent',
                title: '',
                icon: <AutorenewIcon />,
                show: (rec) => {
                  const isRecorrent = !!rec.grupo_feriado_id;

                  const dataItem = new Date(
                    moment(rec.data).startOf('day').format(),
                  );

                  const dataAtual = new Date(moment().startOf('day').format());

                  const isPassado = dataAtual.getTime() >= dataItem.getTime();

                  return isRecorrent && !isPassado;
                },
              },
              {
                key: 'edit',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (rec) => handleEdit(rec),
                disabled: (rec) => {
                  const dataItem = new Date(
                    moment(rec.data).startOf('day').format(),
                  );

                  const dataAtual = new Date(moment().startOf('day').format());

                  return dataAtual.getTime() >= dataItem.getTime();
                },
              },
              {
                key: 'delete',
                title: 'Deletar',
                icon: <DeleteOutlineIcon />,
                onClick: (rec) => deleteHundle(rec),
                disabled: (rec) => {
                  const dataItem = new Date(
                    moment(rec.data).startOf('day').format(),
                  );

                  const dataAtual = new Date(moment().startOf('day').format());

                  return dataAtual.getTime() >= dataItem.getTime();
                },
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} handleClose={handleClose} />
      <DialogoDeleteResource
        ref={refDialogoDeleteResource}
        handleClose={handleClose}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_FERIADOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Feriados"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
